export default __webpack_public_path__ + "static/media/mObywatel_icon_orange.bd277434.svg";